import React, { useEffect, useState } from "react";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useMutation } from "react-query";
import {
  getAmount,
  getModeOfPayment,
  getWalletDetails,
  printReceipt,
  saveWallet,
} from "./service";

import { clinicId } from "../../constants";
import { useForm } from "react-hook-form";
import Lottie from "lottie-react";
import { CustomFormField } from "../../utilis/component/CustomFormElement";

import animation from "./animation.json";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import moduleRoutes from "../../routes/moduleRouteList";
import dashboardRouteList from "../routeList";
import { Button, CircularProgress, Paper, useTheme } from "@mui/material";
import usePopup from "../../hooks/usePopup";
import useAuthentication from "@hooks/useAuthentication";

type payloadType = {
  paymentId: number;
  patientId: number;
  clinicId: number;
  modeOfPaymentId: number;
  amount: number;
};

const Wallet: React.FC = () => {
  const navigate = useNavigate();
  const [balance, setBalance] = useState(0);
  const location = useLocation();
  const fromReception = location?.state?.wallet;
  const [walletDetails, setWalletDetails] = useState<payloadType[] | null>(
    null
  );
  const { user } = useAuthentication()
  const regionTypeCurrency = user?.region === "QATAR_REGION" ? "QAR" : "AED";
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const { control, handleSubmit, reset } = useForm();
  const {
    control: control2,
    handleSubmit: handleSubmit2,
    reset: reset2,
  } = useForm();

  const { id: patientMasterID } = useParams();
  const { showSnackbar, CustomModal } = usePopup();

  const { mutate: save } = useMutation(saveWallet, {
    onSuccess: (data) => {
      if (data) {
        setWalletDetails((prevDetails) =>
          prevDetails
            ? [{ ...prevDetails[0], paymentId: data?.response?.paymentId }]
            : null
        );
        setLoading(false), setBalance(data.response?.amount), reset();
      }
    },
  });

  const { mutate: getamount } = useMutation(getAmount, {
    onSuccess: (data) => {
      setLoading(false);
      setBalance(data.response[0].amount);
      setWalletDetails(data.response);
    },
  });
  const { mutate: getPaymentList, data: modeOfPaymentList } = useMutation(
    getModeOfPayment,
    {
      onSuccess: (data) => {
        console.log(data);
      },
    }
  );

  useEffect(() => {
    getPaymentList();
    getamount(parseInt(patientMasterID as string));
  }, []);

  const { mutate: getPaymentPrint, isLoading: printLoading } = useMutation(
    printReceipt,
    {
      onSuccess: (data: any) => {
        if (data.responseIndicator == "success" && data.response) {
          const binaryData = atob(data.response);

          const byteNumbers = new Uint8Array(binaryData.length);
          for (let i = 0; i < binaryData.length; i++) {
            byteNumbers[i] = binaryData.charCodeAt(i);
          }
          const blob = new Blob([byteNumbers], { type: "application/pdf" });
          const blobURL = URL.createObjectURL(blob);
          window.open(blobURL, "_blank");
        } else {
          showSnackbar({
            message: "Failed to download Receipt",
            open: true,
            variant: "error",
            duration: 2000,
          });
        }
      },
    }
  );
  const { mutate: getstatement, isLoading: statementLoading } = useMutation(
    getWalletDetails,
    {
      onSuccess: (data: any) => {
        const base64File = data?.response?.items?.[0];

        // Case 1: No data (empty array)
        if (
          data?.responseIndicator === "success" &&
          Array.isArray(data?.response?.items) &&
          data?.response?.items.length === 0
        ) {
          showSnackbar({
            message: data?.response?.responseMessage || "No statement found",
            open: true,
            variant: "info",
            duration: 2000,
          });
          return; // ⬅️ stop here
        }

        // Case 2: Valid base64
        if (data.responseIndicator === "success" && base64File) {
          try {
            const binaryData = atob(base64File.trim());
            const byteNumbers = new Uint8Array(binaryData.length);

            for (let i = 0; i < binaryData.length; i++) {
              byteNumbers[i] = binaryData.charCodeAt(i);
            }

            const blob = new Blob([byteNumbers], { type: "application/pdf" });
            const blobURL = URL.createObjectURL(blob);
            window.open(blobURL, "_blank");
          } catch (error) {
            console.error("Error generating PDF:", error);
            showSnackbar({
              message: "Invalid PDF received",
              open: true,
              variant: "error",
              duration: 2000,
            });
          }
          return;
        }

        // Case 3: Fallback for any other failure
        showSnackbar({
          message:
            data?.response?.responseMessage ||
            data?.responseMessage ||
            "Failed to download statement",
          open: true,
          variant: "error",
          duration: 2000,
        });
      },
    }
  );



  const gethistory = (data: any) => {
    const body = {
      patientId: walletDetails != null && walletDetails[0]?.patientId,
      startDate: data.fromDate,
      endDate: data.toDate,
      clinicId,
    };
    reset2({
      fromDate: "",
      toDate: "",
    });
    getstatement(body);
  };

  const handleSave = (data: any) => {
    console.log(walletDetails);
    if (walletDetails != null) {
      const body = {
        paymentId: walletDetails[0].paymentId,
        patientId:walletDetails[0]?.patientId ? Number(walletDetails[0]?.patientId) : null,
        clinicId: clinicId,
        modeOfPaymentId: data.modeOfPayment.id,
        amount: parseFloat(parseFloat(data?.amount)?.toFixed(2) || "0"),
        transactionType: data.type,
      };
      setLoading(true);
      save(body);
    }
  };

  return (
    <div className="flex flex-col items-start">
      {fromReception && (

        <Paper className="w-[50vw] p-3  flex items-center " sx={{
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }}>
          <Button
            startIcon={<ArrowBackIcon />}
            variant="outlined"
            onClick={() => {
              const base = (window as any)._env_?.BASE_URL || "";
              navigate(`${base}${moduleRoutes.mainRoute}/${moduleRoutes.dashboard}/${dashboardRouteList.reception}?tab=3`);
            }}
          >
            Back
          </Button>
        </Paper>
      )}
      <Paper className=" p-8 rounded-lg shadow-lg w-[50vw] " sx={{
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
      }}>
        <h2 className="text-2xl font-semibold text-gray-700 text-center mb-6">
          Wallet
        </h2>
        <div className="grid grid-cols-12 justify-center items-center gap-x-3  ">
          <div className="col-span-6 space-y-4 ">
            <form className="space-y-4" onSubmit={handleSubmit(handleSave)}>
              <div className="grid grid-cols-12 gap-x-2">
                <div className="col-span-6">
                  <CustomFormField
                    control={control}
                    element="autocomplete"
                    name="type"
                    options={["DEPOSIT", "WITHDRAWAL"]}
                    rules={{ required: "Transaction type  Required" }}
                    fieldProps={{ label: "Type" }}
                  />
                </div>
                <div className="col-span-6">
                  <CustomFormField
                    control={control}
                    element="input"
                    name="amount"
                    rules={{
                      required: "Amount Required",
                      min: { value: 0, message: "Amount must be at least 0" },
                    }}
                    fieldProps={{ label: "Amount", type: "number" }}
                  />
                </div>
              </div>
              <div>
                <CustomFormField
                  control={control}
                  element="autocomplete"
                  name="modeOfPayment"
                  rules={{ required: "mode of payment required" }}
                  fieldProps={{ label: "mode of Payment" }}
                  options={
                    Array.isArray(modeOfPaymentList) ? modeOfPaymentList : []
                  }
                  autocompleteProps={{
                    isOptionEqualToValue: (option, value) =>
                      option.mode == value.mode,
                    getOptionLabel: (option) => option.mode,
                  }}
                />
              </div>
            </form>

            <div className="mt-6 flex gap-x-3">
              <Button
                type="submit"
                onClick={handleSubmit(handleSave)}
                className=" text-white px-4 py-2 rounded-md hover:bg-green-600 focus:ring-2 focus:ring-green-400"
              >
                Save
              </Button>
              <Button
                color="success"
                className=" text-white  rounded-md hover:bg-blue-600 focus:ring-2 focus:ring-blue-400"
                onClick={() =>
                  walletDetails != null &&
                  getPaymentPrint(walletDetails[0]?.patientId as number)
                }
                endIcon={
                  printLoading && <CircularProgress size={20} color="inherit" />
                }
              >
                Print Receipt
              </Button>

              <Button
                color="success"
                className=" text-white  rounded-md "
                onClick={() => {
                  setOpen(true);
                }}
              >
                wallet statement
              </Button>
            </div>
          </div>
          <div className="bg-blue-500 m-5 text-white rounded-md shadow-md w-72 p-6 relative ">
            <div className="absolute top-4 right-4 opacity-20">
              <AccountBalanceWalletIcon style={{ fontSize: "4rem" }} />
            </div>
            <div className="flex items-center">
              {loading ? (
                <Lottie
                  color={theme.palette.background.paper}
                  animationData={animation}
                  style={{ height: "50px", width: "50px" }}
                />
              ) : (
                <p className="text-4xl font-bold mr-2">
                  {" "}
                  {balance?.toFixed(2) || "0"} {regionTypeCurrency}
                </p>
              )}
            </div>
            <p className="text-sm">In Wallet</p>
            <button
              onClick={() => {
                setLoading(true),
                  getamount(parseInt(patientMasterID as string));
              }}
              className="flex items-center justify-center bg-green-700 hover:bg-green-600 rounded-md px-4 py-2 mt-4"
            >
              Refresh
              <ArrowRightAltIcon className="ml-1" />
            </button>
          </div>
        </div>
      </Paper>

      <CustomModal open={open} setOpen={setOpen}>
        <div className="w-[40vw] p-5">
          <form
            className=" grid grid-cols-12 gap-x-2 justify-center items-center "
            onSubmit={handleSubmit2(gethistory)}
          >
            <div className="col-span-4">
              <CustomFormField
                control={control2}
                element="datepicker"
                fieldProps={{ label: "from Date" }}
                rules={{ required: "from date required" }}
                name="fromDate"
                dateFormat="DD-MM-YYYY"
              />
            </div>
            <div className="col-span-4">
              <CustomFormField
                control={control2}
                element="datepicker"
                fieldProps={{ label: "toDate" }}
                rules={{ required: "To date required" }}
                name="toDate"
                dateFormat="DD-MM-YYYY"
              />
            </div>
            <div className="p-2">
              <Button
                type="submit"
                endIcon={
                  statementLoading && (
                    <CircularProgress size={20} color="inherit" />
                  )
                }
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </CustomModal>
    </div>
  );
};
export default Wallet;
